/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Buyer_Consumer_HintInputs */

const vi_einvoice_buyer_consumer_hint = /** @type {(inputs: Einvoice_Buyer_Consumer_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Có thể để trống họ tên nếu bán cho người tiêu dùng không cung cấp tên.`)
};

/**

* @param {Einvoice_Buyer_Consumer_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_buyer_consumer_hint = /** @type {((inputs?: Einvoice_Buyer_Consumer_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Buyer_Consumer_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_buyer_consumer_hint(inputs)
});